function removeDiacritics(str) {
  return str.normalize("NFKD").replace(/[^\w]/g, "");
}

/**
 * Create a FILTER pseudo class. Like CONTAINS, but case insensitive
 */
$.expr[":"].filter = $.expr.createPseudo(function (arg) {
  return function (elem) {
    const element = removeDiacritics($(elem).text()).toUpperCase();
    const keyword = removeDiacritics(arg).toUpperCase();
    return element.indexOf(keyword) >= 0;
  };
});

/**
 * Tiny jQuery Plugin by Chris Goodchild
 * @param {DOM} callback
 */
$.fn.exists = function (callback) {
  var args = [].slice.call(arguments, 1);

  if (this.length) {
    callback.call(this, args);
  }

  return this;
};

/**
 * Get parameter from URL
 * @param {string} key Key to get from URL
 */
export function getUrlParameter(key) {
  key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + key + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/**
 * Create a function to filter each word of search in FAQ
 * @param {string[]} searchArray
 * @param {string[]} keywordArray
 */
export function iterateKeywords(searchArray, keywordArray) {
  for (var index = 0; index < searchArray.length; index++) {
    if (
      searchArray[index] != "" &&
      keywordArray.indexOf(searchArray[index]) >= 0
    ) {
      return true;
    }
  }
  return false;
}

/**
 * Append query to url
 * @param {string} url
 * @param {string} key
 * @param {string} value
 */
export function updateQueryStringParam(url, key, value) {
  var baseUrl = url,
    urlQueryString = document.location.search,
    newParam = key + "=" + value,
    params = "?" + newParam;

  // If the "search" string exists, then build params from it
  if (urlQueryString) {
    var updateRegex = new RegExp("([?&])" + key + "[^&]*");
    var removeRegex = new RegExp("([?&])" + key + "=[^&;]+[&;]?");

    if (typeof value == "undefined" || value == null || value == "") {
      // Remove param if value is empty
      params = urlQueryString.replace(removeRegex, "$1");
      params = params.replace(/[&;]$/, "");
    } else if (urlQueryString.match(updateRegex) !== null) {
      // If param exists already, update it
      params = urlQueryString.replace(updateRegex, "$1" + newParam);
    } else {
      // Otherwise, add it to end of query string
      params = urlQueryString + "&" + newParam;
    }
  }

  // no parameter was set so we don't need the question mark
  params = params == "?" ? "" : params;

  return baseUrl + params;
}

/**
 * Convert string representative of boolean to boolean
 * @param {string} str
 * @returns boolean
 */
export function strToBool(str) {
  return str === "true" || str === "1" ? true : false;
}

export const formErrorHandler = (error, element) => {
  if (element.parent().hasClass("input-group")) {
    error.insertAfter(element.parent());
  } else {
    error.insertAfter(element);
  }
};
